export default [
    {
        "error_id": "SIC-01",
        "data": [
            {
                "cross_section": "91339"
            },
            {
                "cross_section": "91339"
            },
            {
                "cross_section": "40881"
            },
            {
                "cross_section": "40881"
            }
        ]
    }
]